export default __webpack_public_path__ + "static/2131-3ed251aca6c4be1e84a86f1038665dcd.gif";